import {Injectable} from '@angular/core';
import {LoginHelper} from '../helpers';

import {AuthenticationService} from './index';
import {Subject} from "rxjs";
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class AccessRequestService {
  updateList = new Subject();

    constructor(public http: HttpClient,
                public authenticationService: AuthenticationService,
                public config: IndexConfigService) { }

  @Load()
  createAccessRequest(accessRequest: string) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();
      return null;
    }

    return this.http.put(this.config.api + '/api/accessRequest', accessRequest);
  }
  @Load()
  getAccessRequests() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/accessRequest');
  }
  @Load()
  getAccessRequest(id: number) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + `/api/accessRequest/${id}`);
  }
  @Load()
  getAccessRequestForUser() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + `/api/accessRequest/currentUser`);
  }
  @Load()
  setAccessRequestStatus(accessRequest, status) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + `/api/accessRequest/${accessRequest}/${status}`, {});
  }
}
